const buildSlugFromNameAndId = ({ id, name }: { id: number; name: string }) => {
  if (!name) {
    return String(id);
  }
  const replaced = name.replace(/\s+/g, '-').toLowerCase();
  return `${replaced}-${id}`;
};

export default buildSlugFromNameAndId;
